export const USER_STATUS = {
    ADMIN: '1'
}